import { render, staticRenderFns } from "./TemperatureNew.vue?vue&type=template&id=2920e06f"
import script from "./TemperatureNew.vue?vue&type=script&lang=js"
export * from "./TemperatureNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports